import { Item } from "@common/ADAPT.Common.Model/organisation/item";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { ProcessMapPageComponent } from "./process-map-page.component";

export const processMapPageRoute = new OrganisationPageRouteBuilder<{ itemCodeOrId: string }, Item>()
    .usingNgComponent("adapt-process-map-page", ProcessMapPageComponent)
    .atOrganisationUrl("/process-maps/:processMapId")
    .build();
